import { endPoint } from './base.config';

export const voucherSuggestion = {
  update: endPoint + 'voucherSuggestions/:id',
};
